import script from "./ArticleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleManagement.vue?vue&type=script&setup=true&lang=js"

import "./ArticleManagement.vue?vue&type=style&index=0&id=3da0f97c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da0f97c"]])

export default __exports__